import React from 'react';

import HeaderBackButton from '@/components/Header/HeaderBackButton';
import { HeaderProps } from '@/components/Header/types';

import styles from './GameDetailsHeader.module.scss';

interface GameDetailsHeaderPropsType {
  backButtonText: HeaderProps['backButtonText'];
  onBackButtonClick: HeaderProps['onBackButtonClick'];
}

/**
 * @deprecated Replaced with another component in the scope of the New Vegas, to
 *   remove after the New Vegas release
 */
const GameDetailsHeader: React.FC<GameDetailsHeaderPropsType> = ({
  backButtonText,
  onBackButtonClick,
}) => {
  return (
    <div
      className={styles.headerWrapper}
      data-testid="game-details-simple-header"
    >
      <HeaderBackButton
        backButtonText={backButtonText}
        onBackButtonClick={onBackButtonClick}
      />
    </div>
  );
};

export default GameDetailsHeader;
